import React from "react";
import {useLocation} from "react-router-dom";
import classNames from "classnames";
import SectionTitle from "@components/LeftMenu/SectionTitle";
import SectionLink from "@components/LeftMenu/SectionLink";
import {routeCodes} from "@constants/routes";

import "./MenuMinhaConta.scss";

function MenuMinhaConta() {
  const location = useLocation();
  const isActive = (value) => {
    if (location.pathname === value) return true;
    return false;
  };

  return (
    <React.Fragment>
      <h4 className="navigation-section-title-sm purple-text bold small-only">Geral</h4>

      <SectionTitle
        title="Geral"
        className="navigation-section-title purple-text bold uppercase large-only"
      />

      <div className="sections-wrp">
        <SectionLink
          title="Editar Perfil"
          link={routeCodes.GERAL_EDITAR_PERFIL}
          className={classNames({
            "navigation-section-link": true,
            "purple-text": true,
            bold: true,
            "mt-5": true,
            active: isActive(routeCodes.GERAL_EDITAR_PERFIL),
          })}
        />
        <SectionLink
          title="Alterar Senha"
          link={routeCodes.GERAL_ALTERAR_SENHA}
          className={classNames({
            "navigation-section-link": true,
            "purple-text": true,
            bold: true,
            "my-3": true,
            active: isActive(routeCodes.GERAL_ALTERAR_SENHA),
          })}
        />
      </div>
      {/*<SectionLink
        title="Email e SMS"
        link={routeCodes.GERAL_EMAIL_SMS}
        className={classNames({
          "navigation-section-link": true,
          "purple-text": true,
          bold: true,
          "my-3": true,
          active: isActive(routeCodes.GERAL_EMAIL_SMS),
        })}
      />*/}
    </React.Fragment>
  );
}

export default MenuMinhaConta;
